import React from "react";
import { Controller } from "react-hook-form";
import ToggleableButton from "../../../../components/toggleableButton/toggleableButton";
import { Input } from "../../../../components/form/Input/Input";

export const Extra = ({ control, register }) => {
  return (
    <>
      <div className="admin-organizations__section">
        <div className="switch">
          <p className="switch__title">Calculate historical data</p>
          <Controller
            control={control}
            name="calculate_historical_data"
            render={({ field: { onChange, value } }) => {
              return (
                <div className={`switch__content ${value ? "switch__content--active" : ""}`}>
                  <ToggleableButton
                    isRadio
                    title="calculate_historical_data"
                    isActive={value}
                    onClick={(isActive) => onChange(isActive)}
                  />
                </div>
              );
            }}
          />
        </div>

        <div className="switch">
          <p className="switch__title">Calculate challengers</p>
          <Controller
            control={control}
            name="calculate_challengers"
            render={({ field: { onChange, value } }) => {
              return (
                <div className={`switch__content ${value ? "switch__content--active" : ""}`}>
                  <ToggleableButton
                    isRadio
                    title="calculate_challengers"
                    isActive={value}
                    onClick={(isActive) => onChange(isActive)}
                  />
                </div>
              );
            }}
          />
        </div>
      </div>

      <div className="admin-organizations__section">
        <div className="switch">
          <p className="switch__title">Show network averages</p>
          <Controller
            control={control}
            name="show_laser_network_averages"
            render={({ field: { onChange, value } }) => {
              return (
                <div className={`switch__content ${value ? "switch__content--active" : ""}`}>
                  <ToggleableButton
                    isRadio
                    title="show_laser_network_averages"
                    isActive={value}
                    onClick={(isActive) => onChange(isActive)}
                  />
                </div>
              );
            }}
          />
        </div>

        <div className="switch">
          <p className="switch__title">Leaderboard details</p>
          <Controller
            control={control}
            name="leaderboard_details"
            render={({ field: { onChange, value } }) => {
              return (
                <div className={`switch__content ${value ? "switch__content--active" : ""}`}>
                  <ToggleableButton
                    isRadio
                    title="leaderboard_details"
                    isActive={value}
                    onClick={(isActive) => onChange(isActive)}
                  />
                </div>
              );
            }}
          />
        </div>
      </div>
      <p>At risk members threshold</p>
      <div className="admin-organizations__section">
        <Input
          label="Days from the last visit"
          htmlFor="risk_members_days_from_last_visit"
          customProps={register("risk_members_days_from_last_visit")}
          inputType="number"
        />

        <Input
          label="Days previous to the last visit"
          htmlFor="risk_members_days_prev_last_visit"
          customProps={register("risk_members_days_prev_last_visit")}
          inputType="number"
        />
      </div>
    </>
  );
};
